import React from "react";
import user_icon from "../../../img/Icon/user_icon.svg";
import email_icon from "../../../img/Icon/email.svg";
import phone_icon from "../../../img/Icon/phone.svg";
import ven from "../../../img/ven.png";
import starticon from "../../../img/Icon/starticon.png";
import { getHijriParts } from "../../HijriCalendar/getHijriDate";
import MiqaatBadge from "../../HijriCalendar/MiqaatBadge";

// Taste/Quantity/Dish collapsed into one overall Rating (their average) -
// a 0/blank component rating means that aspect wasn't rated, not "rated 0",
// so it's excluded from the average rather than dragging it down. Kept in
// sync with the identical helper in Feedback.js.
function getOverallRating(fb) {
  const ratings = [fb.taste_rating, fb.quantity_rating, fb.dish_rating]
    .map((r) => Number(r))
    .filter((r) => !Number.isNaN(r) && r > 0);
  if (ratings.length === 0) return null;
  return ratings.reduce((sum, r) => sum + r, 0) / ratings.length;
}

// schedule_day comes down as "MM-DD-YYYY..." (not ISO "YYYY-MM-DD") - same
// parsing Feedback.js's own convertDateForIos already uses successfully for
// this exact field. The previous version here assumed ISO order and split
// on "-" directly, which fed the DAY position into what it treated as the
// YEAR (and vice versa) - the wrong/garbled year the header showed.
function convertDateForIos(date) {
  const arr = date.split(/[- :]/);
  return new Date(arr[2], arr[0] - 1, arr[1]);
}

// The dish/caterer/date/remarks summary + the feedback list itself, shared
// between the standalone /ScheduleFeedback route and the modal Feedback.js
// opens in place of navigating there - the same content either way, minus
// the page chrome (Header/Sidebarmenu), which only the standalone route
// needs.
export default function ScheduleFeedbackContent({ item, feedbacks }) {
  const user_Role = localStorage.getItem("access_Role");
  // Averaged straight from the individual feedbacks just fetched for this
  // schedule (always the full unfiltered set, regardless of any rating
  // filter applied on the list page) - NOT from item's own
  // taste/quantity/dish_rating fields, which come back reflecting whatever
  // rating filter was active on the list when item was fetched (so the
  // header could otherwise show 1, or the selected filter rating, instead
  // of the schedule's true overall average).
  const feedbackRatings = (feedbacks || [])
    .map((fb) => getOverallRating(fb))
    .filter((r) => r != null);
  const overallRating =
    feedbackRatings.length > 0 ? feedbackRatings.reduce((sum, r) => sum + r, 0) / feedbackRatings.length : null;
  const scheduleDate = item.schedule_day ? convertDateForIos(item.schedule_day) : null;
  const dayInformation = scheduleDate
    ? `${scheduleDate.toLocaleString("en-US", { weekday: "long" })}, ${scheduleDate.toLocaleString("en-US", {
        month: "long",
      })} ${scheduleDate.getDate()}, ${scheduleDate.getFullYear()}`
    : "";

  return (
    <div className="thali_table_section TotalIngredientstable">
      <table className="table">
        <thead className="thead-dark">
          <tr>
            <th scope="col">
              <span className="thali_table">Dishes</span>
            </th>
            <th scope="col">
              <span className="thali_table">Caterers</span>
            </th>
            <th scope="col">
              <span className="thali_table">Date</span>
            </th>
            <th scope="col">
              <span className="thali_table">Rating</span>
            </th>
            <th scope="col">
              <span className="thali_table">Remarks</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">
              <ul className="thali_menu_list">
                {item.save_draft == "1" && (
                  <span className="Draft_thali_event">{item.save_draft == "1" ? "Draft" : ""}</span>
                )}
                {item.schedule_type == "MIQAAT" && item.is_niyaaz != "1" && (
                  <span className="Draft_MIQAAT_event">{item.schedule_type == "MIQAAT" ? "MIQAAT" : ""}</span>
                )}
                {item.schedule_type == "MIQAAT" && item.is_niyaaz == "1" && (
                  <span className="Draft_NIYAAZ_event">
                    {item.schedule_type == "MIQAAT" && item.is_niyaaz == "1" ? "PRIVATE" : ""}
                  </span>
                )}
                {item.schedule_type == "FMBTHALI" && item.is_niyaaz == "1" && (
                  <span className="Draft_NIYAAZ_event">
                    {item.schedule_type == "FMBTHALI" && item.is_niyaaz == "1" ? "MIQAAT-THALI" : ""}
                  </span>
                )}
                {item.menu &&
                  JSON.parse(item.menu).map((menu, index) => <li key={index}>{menu ? menu : "NA"}</li>)}
              </ul>
            </th>
            <th scope="row">
              {item.jamanType == "COOKING" && (
                <ul className="thali_menu_list">
                  {item.cater_name1 != null && item.cater_name1 !== "" && (
                    <li>
                      &nbsp;
                      <img src={user_icon} className="img-fluid" alt="" />
                      &nbsp;&nbsp;{item.cater_name1}
                    </li>
                  )}
                  {item.cater_name2 != null && item.cater_name2 !== "" && (
                    <li>
                      <img src={user_icon} className="img-fluid" alt="" />
                      {item.cater_name2}
                    </li>
                  )}
                  {item.cater1_email && item.cater1_email !== "null" && (
                    <li>
                      <img src={email_icon} className="img-fluid" width="22px" height="22px" alt="" />
                      &nbsp;
                      {item.cater1_email ? item.cater1_email : "NA"}
                    </li>
                  )}
                  {item.cater1_phone_number && item.cater1_phone_number !== "null" && (
                    <li>
                      &nbsp;
                      <img src={phone_icon} className="img-fluid" width="18px" height="18px" alt="" />
                      &nbsp;
                      {item.cater1_phone_number ? item.cater1_phone_number : "NA"}
                    </li>
                  )}
                </ul>
              )}
              {item.jamanType == "ORDERING" && (
                <ul className="thali_menu_list">
                  <li>
                    {item.jamanType == "ORDERING" && (
                      <span className="Draft_ordering_event">
                        {item.jamanType == "ORDERING" ? "ORDERING" : ""}
                      </span>
                    )}
                  </li>
                  <li>
                    <img src={ven} className="img-fluid" width="16px" height="16px" alt="" />
                    &nbsp; &nbsp;
                    {item.order_by ? item.order_by : "-"}
                  </li>
                </ul>
              )}
            </th>
            <th scope="row">
              <ul className="thali_menu_list">
                <li>
                  <span className="Date_list">{dayInformation ? dayInformation : ""}</span>{" "}
                </li>
                {scheduleDate && (
                  <li>
                    <span className="Date_list" style={{ color: "#591333", fontSize: "1em" }}>
                      {getHijriParts(scheduleDate).day} {getHijriParts(scheduleDate).month}
                    </span>
                  </li>
                )}
              </ul>
            </th>
            <th scope="row">
              <ul className="thali_menu_list">
                <li>
                  <img src={starticon} className="img-fluid" alt="" />
                  &nbsp;&nbsp;&nbsp;{overallRating != null ? overallRating.toFixed(1) : "-"}
                </li>
              </ul>
            </th>
            <th scope="row">
              <ul className="thali_menu_list">
                <li>{item.notes ? item.notes : "-"}</li>
              </ul>
            </th>
          </tr>
        </tbody>
      </table>

      <div className="thali_table_section">
        <table className="table table-bordered table-responsive">
          <thead className="thead-dark">
            <tr>
              <th scope="col">
                <span className="thali_table">Feedback Day</span>
              </th>
              {user_Role.includes("FBM") && (
                <th scope="col">
                  <span className="thali_table">Name</span>
                </th>
              )}
              <th scope="col">
                <span className="thali_table">Rating</span>
              </th>
              <th scope="col">
                <span className="thali_table">Comment</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {feedbacks &&
              feedbacks.map((fb) => {
                const date = new Date(fb.feedback_date);
                const day = date.toLocaleString("en-US", { weekday: "long" });
                const month = date.toLocaleString("en-US", { month: "long" });
                const numericDate = date.getDate();
                const twoDigitYear = date.getFullYear();
                return (
                  <tr key={fb.id}>
                    <th scope="row">
                      <div className="Calendar_card">
                        <h6>{day}</h6>
                        <h1>{numericDate}</h1>
                        <p>
                          {month}, {twoDigitYear}
                        </p>
                        <p className="hijri_date">
                          <span className="hijri_day">{getHijriParts(date).day}</span>
                          <span className="hijri_month">{getHijriParts(date).month}</span>
                          <MiqaatBadge date={date} />
                        </p>
                      </div>
                    </th>
                    {user_Role.includes("FBM") && (
                      <th scope="row">
                        <ul className="thali_menu_list">
                          <li>{fb.user_name ? fb.user_name : "-"} </li>
                        </ul>
                      </th>
                    )}
                    <th scope="row">
                      <ul className="thali_menu_list">
                        <li>
                          <img src={starticon} className="img-fluid" alt="" />
                          &nbsp;&nbsp;&nbsp;
                          {(() => {
                            const overallRating = getOverallRating(fb);
                            return overallRating != null ? overallRating.toFixed(1) : "-";
                          })()}{" "}
                        </li>
                      </ul>
                    </th>
                    <th scope="row">
                      <ul>
                        <p>
                          <div>
                            <div style={{ fontSize: 14, width: "300px", fontWeight: "420", color: "#2E294E" }}>
                              {fb.comment ? fb.comment : "-"}
                            </div>
                          </div>
                        </p>
                      </ul>
                    </th>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
